import React, { useState, useEffect } from 'react';
import { Table, Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import formatMoney from '../../utils/formatMoney';
import './styles/payments.scss';

const select = state => {
  return {
    token: state.auth.token
  };
};

function ConnectedGroupedPayments(props) {
  const { token } = props;
  const [isLoading, setLoading] = useState(true);
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    async function getPayments() {

      const dataResponse = await fetch(`${apiUrl}/admin/payments/grouped?token=${token}`);
      const dataJson = await dataResponse.json();
      if (dataJson.payments) setPayments(dataJson.payments);
      setLoading(false);
    }
    getPayments();
  }, [token]);

  if (isLoading) return (<AppSpinner />);

  return (
    <Container fluid>
      <Row>
        <Col>

          <h1>Pagos</h1>

          <hr />

          <Table striped bordered hover size="sm" className='paymentTable'>
            <thead>
              <tr>
                <th>Organización</th>
                <th>Recaudado</th>
                <th>Pasarela</th>
                <th>Impuestos</th>
                <th>Comisión nibi</th>
                <th>Disponible</th>
                <th>Desembolsado</th>
                <th>Desc. desembolsos</th>
                <th>Restante</th>
              </tr>
            </thead>
            <tbody>
              {
                payments.map((payment, i) =>
                  <>
                    <tr key={i} style={{ fontWeight: '600', textAlign: 'right' }}>
                      <td style={{ textAlign: 'left' }}>
                        {payment.name}
                      </td>
                      <td>{formatMoney(payment.totalAmount)}</td>
                      <td>{formatMoney(payment.totalPasarela)}</td>
                      <td>{formatMoney(payment.totalTax)}</td>
                      <td>{formatMoney(payment.totalFareNibi)}</td>
                      <td>{formatMoney(payment.totalAvailable)}</td>
                      <td>{formatMoney(payment.totalDisbursed)}</td>
                      <td>{formatMoney(payment.totalTransactions)}</td>
                      <td>{formatMoney(payment.totalLeft)}</td>
                    </tr>
                    {
                      payment.programs.map((program, j) =>
                        <tr key={j} style={{ textAlign: 'right' }}>
                          <td style={{ paddingLeft: '20px', textAlign: 'left' }}>
                            - {program.name ? program.name.substring(0,50) : "Directo a organización"}
                          </td>
                          <td>{formatMoney(program.totalAmount)}</td>
                          <td>{formatMoney(program.totalPasarela)}</td>
                          <td>{formatMoney(program.totalTax)}</td>
                          <td>{formatMoney(program.totalFareNibi)}</td>
                          <td>{formatMoney(program.totalAvailable)}</td>
                          <td>{formatMoney(program.totalDisbursed)}</td>
                          <td>{formatMoney(program.totalTransactions)}</td>
                          <td>{formatMoney(program.totalLeft)}</td>
                        </tr>
                      )
                    }
                  </>
                )
              }
            </tbody>
          </Table>

        </Col>
      </Row>
    </Container>
  );
}

const GroupedPayments = connect(select)(ConnectedGroupedPayments);

export default GroupedPayments;
